export default "__VITE_ASSET__BAtfAUNI__"